import axiosClient from "./axiosClient";

export async function searchCities(query, limit = 20) {
  const response = await axiosClient.get("/Cities/search", { params: { query, limit } });
  return response.data;
}
